import { FC, useMemo } from 'react';
import { t } from 'i18next';
import { Dropdown } from '@ui-modules/informed';
import { IDropdownOption } from '@ui-modules/types';
import { FacilityVehicleMapped } from '@common/interfaces';
import { notEmptyValidator } from '@common/utils';
import '../../BookingPanel.styles.scss';

interface VehicleFieldProps {
  disabled?: boolean;
  leg: number;
  vehicle?: string;
  vehicles: FacilityVehicleMapped[];
  onChange?: (value: IDropdownOption) => void;
}

const VehicleField: FC<VehicleFieldProps> = ({ disabled, leg, vehicle, vehicles, onChange }) => {
  const options = useMemo(
    () =>
      vehicles.map(
        ({ label, vehicleId }: FacilityVehicleMapped): IDropdownOption => ({
          label,
          value: vehicleId,
        }),
      ),
    [vehicles],
  );

  return (
    <div className="field" data-testid={`drive-vehicle-${leg}`}>
      <Dropdown
        className="dropdown"
        defaultValue={options?.find((i) => i.value === vehicle)}
        isDisabled={disabled}
        label={t('mobility.selectVehicle')}
        name={`${leg}.vehicle`}
        options={options}
        validate={notEmptyValidator}
        onChange={onChange}
      />
    </div>
  );
};

export default VehicleField;
